import { render } from "preact";
import { DemoApp } from "./app.js";

const root = document.getElementById("demo-root");
if (root) {
  root.textContent = "";
  root.className = "";
  render(<DemoApp />, root);
}
